import type { ButtonClick, ButtonProps } from "../base/Button.js";
import { useStore } from "shelving/react";
import { useFormContext } from "./Form.js";

export function SubmitButton({ onClick, children = "Submit", mods = "button-default", style, title }: { onClick?: ButtonClick | undefined } & ButtonProps): React.ReactElement {
	const busy = useStore(useFormContext().busy);
	return (
		<button type="submit" className={`button ${busy.value ? "effect-waiting" : ""} ${mods}`} disabled={busy.value} onClick={onClick} style={style} title={title}>
			{children}
		</button>
	);
}
